export default __webpack_public_path__ + "static/media/6.16cb379d.svg";